import { createSlice } from '@reduxjs/toolkit';

interface Role {
    id: number;
    name: string;
    slug: string;
}

interface SubMenu {
    id: number;
    name: string;
    slug: string;
    url: string;
    icon: string;
    permissions: string[];
    sub_menus: SubMenu[] | null;
}

interface Menu {
    id: number;
    name: string;
    slug: string;
    url: string;
    icon: string;
    permissions: string[];
    sub_menus: SubMenu[] | null;
}

interface PermissionState {
    permissions: any;
    navigateTabsArray: Array<Object>;
    nestedPermissionsData: Array<Object>;
    getFilterPermissionsObject: any;
    roles: Role[];
    menus: Menu[];
    moduleUrls: Array<string>;
}

const initialState: PermissionState = {
    permissions: "",
    navigateTabsArray: [],
    nestedPermissionsData: [],
    getFilterPermissionsObject: {},
    roles: [],
    menus: [],
    moduleUrls: [],
};

const modalSlice = createSlice({
    name: 'permissions',
    initialState,
    reducers: {
        setPermission: (state, action) => {
            return { ...state, isOpen: true, ...action.payload };
        },
        clearPermissionState: () => initialState
    },
});

export const { setPermission, clearPermissionState } = modalSlice.actions;
export default modalSlice.reducer;
